import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'boma-portal-right-menu',
  templateUrl: './portal-right-menu.component.html',
  styleUrls: ['./portal-right-menu.component.scss'],
})
export class PortalRightMenuComponent implements OnInit {
  @Input() rightMenuActive;
  @Output() hanldeRightMenuClick = new EventEmitter();
  amount: SelectItem[];

  selectedAmount: any;

  constructor() {
    this.amount = [
      { label: '*****24', value: { id: 1, name: '*****24', code: 'A1' } },
      { label: '*****75', value: { id: 2, name: '*****75', code: 'A2' } },
    ];
  }

  ngOnInit(): void {}
}
